import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SectionTabs, { SectionTab } from '../components/SectionTabs';
import { PageHeader } from '../components/ui';
import Fermentation from './Fermentation';
import FermentationMaintenance from './FermentationMaintenance';
import PostFermentation from './PostFermentation';

const FERMENTATION_TABS: SectionTab[] = [
  { id: 'fermentation', label: 'Fermentation' },
  { id: 'maintenance', label: 'Fermentation Maintenance' },
  { id: 'post-fermentation', label: 'Post Fermentation' }
];

const FermentationSection: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const current = searchParams.get('tab');
  const validIds = FERMENTATION_TABS.map((t) => t.id);
  const activeTab = validIds.includes(current || '') ? (current as string) : 'fermentation';

  const handleTabChange = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-7">
      <PageHeader
        title="Fermentation"
        subtitle="Orchestrate fermentation, maintenance readings, and post-fermentation work in one place."
      />

      <SectionTabs
        tabs={FERMENTATION_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* Mount all subtabs; refetch when tab becomes visible */}
      <div>
        <div hidden={activeTab !== 'fermentation'}>
          <Fermentation tabVisible={activeTab === 'fermentation'} />
        </div>
        <div hidden={activeTab !== 'maintenance'}>
          <FermentationMaintenance tabVisible={activeTab === 'maintenance'} />
        </div>
        <div hidden={activeTab !== 'post-fermentation'}>
          <PostFermentation tabVisible={activeTab === 'post-fermentation'} />
        </div>
      </div>
    </div>
  );
};

export default FermentationSection;


